/** Alinhar a backend sdrScriptEfetivo.ts (ordem de composição). */
export const SDR_UI_SECTIONS: { key: string; label: string }[] = [
  { key: 'objetivo', label: 'Objetivo do script' },
  { key: 'tomIa', label: 'Tom da IA' },
  { key: 'fase01_abertura', label: '1. Abertura (reengajamento)' },
  { key: 'fase02_followup1', label: '2. Follow-up 1' },
  { key: 'fase03_qualificacao', label: '3. Qualificação inicial' },
  { key: 'fase04_investigacao', label: '4. Investigação' },
  { key: 'fase05_conexao', label: '5. Conexão' },
  { key: 'fase06_oferta', label: '6. Oferta' },
  { key: 'fase07_intencao', label: '7. Intenção' },
  { key: 'fase08_objecoes', label: '8. Objeções' },
  { key: 'fase09_pre_fechamento', label: '9. Pré-fechamento' },
  { key: 'fase10_transferencia', label: '10. Transferência' },
  { key: 'followup_final', label: 'Follow-up final' },
  { key: 'regras', label: 'Regras' },
];

export function buildSdrPreviewFromState(
  mode: 'full' | 'sections',
  sdrScript: string,
  sdrSections: Record<string, string>
): string {
  const t = sdrScript.trim();
  if (mode === 'full' && t) return t;
  const parts: string[] = [];
  for (const { key, label } of SDR_UI_SECTIONS) {
    const body = (sdrSections[key] || '').trim();
    if (body) parts.push(`## ${label}\n\n${body}`);
  }
  return parts.join('\n\n') || t;
}
